document.addEventListener('DOMContentLoaded', () => {
  const colorSwatches = document.querySelectorAll('.custom-color-swatches');
 
  if (colorSwatches.length > 0) {
    colorSwatches.forEach((colorSwatch) => {
      const swatchName = colorSwatch.dataset.optionName;
      const select = document.querySelector(`.hidden__select[name="${swatchName}"]`);
      const selectOptions = select.querySelectorAll('option');
      const optionsArr = [];
      
      selectOptions.forEach((option) => {
        optionsArr.push(option.value);
      });

      const swatchLabels = colorSwatch.querySelectorAll('label');

      swatchLabels.forEach((swatchLabel) => {
        const labelValue = swatchLabel.querySelector('input').value;
        if (!optionsArr.includes(labelValue)) {
          swatchLabel.classList.add('swatch-unavailable');
        }  else {
          swatchLabel.classList.remove('swatch-unavailable');
        }

        swatchLabel.addEventListener('click', () => {
          swatchLabels.forEach((innerSwatchLabel) => {
            innerSwatchLabel.querySelector('input').checked = false;
            innerSwatchLabel.classList.remove('selected');
          });
          const swatchLabelInput = swatchLabel.querySelector('input');
          swatchLabelInput.checked = true;
          select.value = swatchLabelInput.value;
          const nEvent = new Event('change', { bubbles: true });
          select.dispatchEvent(nEvent);
          swatchLabel.classList.add('selected');
        });
      });
      const config = { childList: true };
      const callback = function(mutationsList, observer) {
        for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {
              const newSelect = document.querySelector(`.hidden__select[name="${swatchName}"]`);
              const newSelectOptions = newSelect.querySelectorAll('option');
              const newOptionsArr = [];
      
              newSelectOptions.forEach((option) => {
                newOptionsArr.push(option.value);
              });

              const swatchLabels = colorSwatch.querySelectorAll('label');
              swatchLabels.forEach((swatchLabel) => {
                const labelValue = swatchLabel.querySelector('input').value;

                if (!newOptionsArr.includes(labelValue)) {
                  swatchLabel.classList.add('swatch-unavailable');
                } else {
                  swatchLabel.classList.remove('swatch-unavailable');
                }
              });
            }
        }
      };
      const observer = new MutationObserver(callback);
      observer.observe(select, config);
    });
  }
});



